import { useTranslation } from '@/lib/i18n/i18n.client';

import Button from '@/decodo/components/atoms/Button';
import Heading from '@/decodo/components/atoms/Heading';
import { Text } from '@/decodo/components/atoms/Text';

import IconContentFace from '~/icons/face-content.svg';

type LeadPopUpFormSuccessProps = {
  onClose?: () => void;
};

export function LeadPopUpFormSuccess({ onClose }: LeadPopUpFormSuccessProps) {
  const { texts } = useTranslation();

  return (
    <div className='m:items-center flex flex-col'>
      <div className='mb-6 flex items-center gap-3'>
        <IconContentFace className='text-success-500 flex h-8 w-8 items-center' />
        <Heading level='h3'>
          {texts.contact_sales.success.sent_successfully}
        </Heading>
      </div>
      <Text
        variant='body-l'
        classNames={{ wrapper: 'mb-4 m:mb-12 text-gray-500 ' }}
      >
        {texts.contact_sales.success.thank_you_message}
      </Text>

      <Button onClick={onClose} classNames={{ root: 'w-full' }}>
        {texts.contact_sales.success.close}
      </Button>
    </div>
  );
}
